import { SubscriptionInfoService } from './../subscription-packages/subscription-info-service.service';
import { SharedModule } from './../../shared/shared.module';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppLoginComponent } from './app-login.component';
import { LoginService } from '../login/services/login.service';
import { TranslateService } from '@ngx-translate/core';
// import { RegistrationModule } from './../registration/registration.module';

export const loginRouting: ModuleWithProviders = RouterModule.forChild([]);

@NgModule({
  declarations: [AppLoginComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    loginRouting,
    SharedModule
    // RegistrationModule
  ],
  exports: [AppLoginComponent],
  providers: [LoginService,TranslateService, SubscriptionInfoService, NgbTooltipConfig],
})
export class AppLoginModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/app-login/app-login.module.ts